import React from 'react';
import FooterNav from './FooterNav';

// Left column services (under SERVICES title)
const leftServices = [
  {
    title: 'BRANDING',
    tagline: 'The foundation.',
    items: [
      'Naming & messaging',
      'Brand strategy & positioning',
      'Visual identity systems',
      'Packaging design & brand applications'
    ]
  },
  {
    title: 'CREATIVE DIRECTION',
    tagline: 'Where vision is defined.',
    items: [
      'Creative concept development',
      'Campaign ideation & narrative building',
      'Creative strategy & storytelling frameworks',
      'Visual world creation & moodboarding',
      'Launch concepts & creative direction planning'
    ]
  },
  {
    title: 'ART DIRECTION',
    tagline: 'How the ideas take form.',
    items: [
      'Art direction for campaigns and content shoots',
      'Visual curation & aesthetic refinement',
      'Styling direction, set design & prop styling',
      'Casting direction (models, talent, creators)',
      'Brand expression across visuals'
    ]
  }
];

// Right column services
const rightServices = [
  {
    title: 'PRODUCTION',
    tagline: 'Execution with precision.',
    items: [
      'Photo & video production',
      'Production planning & coordination',
      'Crew sourcing & management',
      'On-set direction & execution',
      'Asset delivery & content optimization'
    ]
  },
  {
    title: 'SOCIAL MEDIA MANAGEMENT',
    tagline: 'Ongoing presence with intention.',
    items: [
      'Social strategy & platform positioning',
      'Content calendars & planning',
      'Feed curation & visual consistency',
      'Posting, engagement & audience growth',
      'Performance insights & reporting'
    ]
  },
  {
    title: 'CONTENT CURATION',
    tagline: 'Content designed to live everywhere.',
    items: [
      'Content strategy',
      'Photo & video content creation',
      'Creative copywriting',
      'Multi-platform content libraries',
      'Performance insights & optimization'
    ]
  },
  {
    title: 'EXPERIENTIAL MARKETING',
    tagline: 'Immersive brand moments.',
    items: [
      'Experiential concepts & activations',
      'Experiential strategy & brand moments',
      'Event creative direction',
      'Brand application across physical spaces',
      'Guest, influencer & community curation'
    ]
  }
];

const ServiceItem = ({ service }) => (
  <div className="service-item">
    <h3>{service.title}</h3>
    <h4>{service.tagline}</h4>
    <ul>
      {service.items.map((item, index) => (
        <li key={index}>{item}</li>
      ))}
    </ul>
  </div>
);

const Services = ({ onNavigate, isActive, currentPage }) => {
  return (
    <section id="services" className={`page ${isActive ? 'active' : ''}`}>
      <div className="services-wrapper">
        <div className="services-container">
          {/* Left column: Intro */}
          <div className="services-intro">
            <p>Our work is designed to matter. We create relevance, influence, and measurable results that extend beyond the present. We value not only the impact we make with you, but also how your brand shows up and creates lasting impact for your community.</p>
          </div>
          
          {/* Middle column: SERVICES title + left services */}
          <div className="services-column-middle">
            <h2 className="services-title">SERVICES</h2>
            <div className="services-list">
              {leftServices.map((service, index) => (
                <ServiceItem key={index} service={service} />
              ))}
            </div>
          </div>
          
          {/* Right column: right services */}
          <div className="services-column-right">
            {rightServices.map((service, index) => (
              <ServiceItem key={index} service={service} />
            ))}
          </div>
        </div>
      </div>
      <FooterNav onNavigate={onNavigate} currentPage={currentPage} />
    </section>
  );
};

export default Services;
